import { Trans, useTranslation } from "react-i18next";
import style from "./style.module.scss";
import { clx } from "../../../helpers/components";
import React, {useEffect, useState} from "react"
import { motion } from 'framer-motion';
import { FaqAccordion } from "../../pages/faq/FaqAccordion";
import { Link, useLocation, useNavigate } from "react-router-dom"
// import { BsCardList } from "react-icons/bs";

export const CheckAndHideFooter = () => {
        const notifExist = localStorage.getItem('notif')
        const ftElement = document.querySelector('#preloader');
        if(notifExist || !notifExist) {
            if (ftElement) { 
                ftElement.style.height = '100%';
            }
            
        }
}

export function CGUSection() {
    const {t}=useTranslation("translations")
    const questions = [
        {
            title: t("general-conditions.allTerms.terms.accessibility.title"),
            description: <Accessibility />
        },
        {
            title: t("general-conditions.allTerms.clause.title"),
            description: <Clause />

        },
        {
            title:    t("general-conditions.allTerms.fiscality.title"),
            description: <Fiscality />
        },
        {
            title: t("general-conditions.allTerms.personnalData.title"),
            description: <Personnal />
        },
        {
            title:    t("general-conditions.allTerms.litige.title"),
            description: <Litige />
        },
        {
            title: t("general-conditions.allTerms.property.title"),
            description: <Property />
        },
        {
            title: t("general-conditions.allTerms.specificRules.title"),
            description: <SpecificRules />
        },
        {
            title:  t("general-conditions.allTerms.generalRules.title"),
            description: <GeneralRules />
        },
        {
            title:t("general-conditions.allTerms.responsability.title"),
            description: <Warning />
        },
        
    ]

    const [index, setIndex] = React.useState(null)
    const handleOpen = (i) => {
        setIndex(prev => i === prev ? null : i)
    }
    return (
        <div className={style.section}>
            <div className={style.sectionContainer}>
                {
                    questions.map((q, i) => (
                        <FaqAccordion
                            key={i}
                            title={q.title}
                            isOpen={i === index}
                            onOpen={() => handleOpen(i)}
                        >
                            {q.description}
                        </FaqAccordion>
                    ))
                }
            </div>

        </div>
    )
}

export function GeneralConditions() {
    const { t } = useTranslation("translations")
    // const [open, setOpen] = React.useState(null)
    // const [loading, setLoading] = React.useState(localStorage.getItem('isLoading') === 'true' || false)
    
    useEffect(()=>CheckAndHideFooter(),[])
    return (
        <>
            <section>
                <div className={style.container_content}>
                    <div className={style.conditions}>
                        <div className={style.wrapperContent}>
                            <div>
                                <h2 className="">{t("general-conditions.pageTitle")}</h2>
                                <p className="mt-2rem h2z">{t("general-conditions.description")}</p>
                            </div>
                            <div className="mt-2rem">
                                <h3 className="">{t("general-conditions.whoAreWe.title")}</h3>
                                <p className="mt-2rem ">{t("general-conditions.whoAreWe.description")}</p>
                            </div>
                            <div className="mt-2rem">
                                <h3 className="">{t("general-conditions.whatDoWeDo.title")}</h3>
                                <p className="mt-2rem ">{t("general-conditions.whatDoWeDo.description-1")}</p>
                                <ul>
                                    <li>{t("general-conditions.whatDoWeDo.description-2")}</li>
                                    <li>{t("general-conditions.whatDoWeDo.description-3")}</li>
                                </ul>
                                <p className="mt-2rem ">{t("general-conditions.whatDoWeDo.description-4")}</p>
                            </div>
                            <div className="mt-2rem">
                                <h3 className="">{t("general-conditions.termsScope.title")}</h3>
                                <p className="mt-2rem ">{t("general-conditions.termsScope.description")}</p>
                            </div>
                            <div className="mt-3rem ">
                                <div className={style.listTerms}>
                                    <h5 style={{marginBottom: 30}}>{t("general-conditions.allTerms.title")}</h5>
                                    <CGUSection />
                                    {/* <ul>
                                    
                                        <li onClick={() => setOpen("accessibilty")}>
                                            {t("general-conditions.allTerms.terms.accessibility.title")}
                                        </li>
                                        
                                    
                                        <li onClick={() => setOpen("clause")}>
                                            {t("general-conditions.allTerms.clause.title")}
                                        </li>
                                        <li onClick={() => setOpen("property")}>{t("general-conditions.allTerms.property.title")}</li>
                                        <li onClick={() => setOpen("fiscality")}>
                                            {t("general-conditions.allTerms.fiscality.title")}
                                        </li>
                                        <li onClick={() => setOpen("specificrules")}>{t("general-conditions.allTerms.specificRules.title")}</li>
                                        <li onClick={() => setOpen("personnal")}>
                                            {t("general-conditions.allTerms.personnalData.title")}
                                        </li>
                                        <li onClick={() => setOpen("GeneralRules")}>{t("general-conditions.allTerms.generalRules.title")}</li>
                                        <li onClick={()=>navigate("/lexical")}>{t("general-conditions.allTerms.lexical.title")}</li>
                                        <li onClick={() => setOpen("Responsability")}>{t("general-conditions.allTerms.responsability.title")}</li>
                                        <li onClick={() => setOpen("litige")}>{t("general-conditions.allTerms.litige.title")}</li>
                                    </ul> */}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </>
    )
}

export function Accessibility() {
    const { t } = useTranslation("translations")
    return (
        <div>
            {/* <h3>{t("general-conditions.allTerms.terms.accessibility.title").toUpperCase()}</h3> */}
            <div className="mt-1rem">
                <h4>{t("general-conditions.allTerms.terms.accessibility.description.1.title")}</h4>
                <p className="mt-1rem">{t("general-conditions.allTerms.terms.accessibility.description.1.description")}</p>
            </div>
            <div className="mt-1rem">
                <h4>{t("general-conditions.allTerms.terms.accessibility.description.2.title")}</h4>
                <p className="mt-1rem">{t("general-conditions.allTerms.terms.accessibility.description.2.description")}</p>
            </div>
            <div className="mt-1rem">
                <h4>{t("general-conditions.allTerms.terms.accessibility.description.3.title")}</h4>
                <p className="mt-1rem">{t("general-conditions.allTerms.terms.accessibility.description.3.description")}</p>
            </div>
            <div className="mt-1rem">
                <h4>{t("general-conditions.allTerms.terms.accessibility.description.4.title")}</h4>
                <p className="mt-1rem">{t("general-conditions.allTerms.terms.accessibility.description.4.description")}</p>
            </div>
            <div className="mt-1rem">
                <h4>{t("general-conditions.allTerms.terms.accessibility.description.5.title")}</h4>
                <p className="mt-1rem">{t("general-conditions.allTerms.terms.accessibility.description.5.description")}</p>
            </div>
            <div className="mt-1rem">
                <h6>{t("general-conditions.allTerms.terms.accessibility.description.clientService")}</h6>
                <h6 className="mt-10">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.terms.accessibility.description.reachatadress"}>
                        Par e-mail à  <span className="text-primary">{{ email: "info@izichange.com" }}</span>
                    </Trans>
                </h6>
                <h6 className="mt-10">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.terms.accessibility.description.reachWhatsappAt"}>
                        Par whatsapp, au <span className="text-primary">{{ tel: "+22991920447" }}</span>, aux horaires indiqués
                    </Trans>
                </h6>
                <h6 className="mt-10">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.terms.accessibility.description.reachDirectionAt"}>
                        Par courrier électronique à adresser à IZICHANGE SAS: <span className="text-primary">{{ dir_eamil: "direction@izichange.com" }}</span>
                    </Trans>
                </h6>
            </div>

        </div >
    )
}

export function Clause() {
    const { t } = useTranslation("translations")
    return (
        <div>
            {/* <h3>{t("general-conditions.allTerms.clause.title").toUpperCase()}</h3> */}
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.clause.description")}</p>
            </div>
        </div >
    )
}

export function Personnal() {
    const { t } = useTranslation("translations")
    return (
        <div>
            {/* <h3>{t("general-conditions.allTerms.personnalData.title").toUpperCase()}</h3> */}
            <div className="mt-1rem">
                <p className="mt-1rem">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.personnalData.description"}>
                        IZICHANGE s’engage à tout mettre en œuvre pour assurer la sécurité et la confidentialité des données personnelles conformément aux dispositions légales et réglementaires en vigueur.<br />IZICHANGE s’engage à ce que seul le Personnel habilité soit autorisé à accéder aux données à caractère personnel de l’Utilisateur.<br />L’accès aux locaux et aux serveurs sur lesquels les données sont collectées, traitées et archivées est strictement limité.<br />Des mesures techniques et organisationnelles appropriées ont été prises afin d’interdire l’accès à toute personne non autorisée.<br />L’Utilisateur est informé lors de l’ouverture de son Compte et dans Les présentes Conditions générales que IZICHANGE collecte et traite de manière automatisée des données à caractère personnel les concernant.<br />Plus généralement, l’Utilisateur consent à l’application de la Politique de Confidentialité de IZICHANGE.<br />La collecte et le traitement des données à caractère personnel réalisées par IZICHANGE en sa qualité de responsable de traitement au sens de la Loi n° 2009-09 portant protection des données à caractère personnel en République du Bénin et de la Loi n° 2017-20 portant code du numérique en République du Bénin (en son Livre 5ème relatif à la protection des données personnelles et de la vie privée) sont nécessaires à l’ouverture d’un Compte Utilisateur et à la réalisation des Services, à la constitution de fichiers clientèle, à la bonne administration des relations commerciales entre les Utilisateurs et IZICHANGE et permettent d’améliorer l’expérience client et/ou permettent de personnaliser l’expérience client. Ces données sont destinées à IZICHANGE ainsi qu’à ses prestataires et partenaires situés dans et hors de la République du Bénin aux fins des présentes, mais ne seront pas utilisés par des tiers dans le but de démarcher les Utilisateurs.<br />L’Utilisateur dispose à tout moment d’un droit d’accès, de modification, de rectification et d’opposition pour des motifs légitimes, ainsi que de son droit à la limitation du traitement ou à la portabilité des données personnelles le concernant qu’il peut exercer en écrivant à IZICHANGE SAS / Service Conformité et Gestion des Données à l’adresse e-mail suivante : compliance@izichange.com .<br />Les données personnelles du Client sont conservées pour la plus longue des durées nécessaires au respect des dispositions légales et réglementaires applicables.<br />La majorité des informations sont conservées pendant la durée minimum légale prévue par les dispositions légales et réglementaires relatives à la lutte contre le blanchiment de capitaux et le financement du terrorisme.<br />En cas de litige lié à l’utilisation de ses données par IZICHANGE, le Client est informé qu’il peut saisir l’Autorité de Protection des Données à caractère Personnel (APDP) via le site internet suivant :
                    </Trans>
                    <a href="https://apdp.bj/" aria-label="lien vers apdp" target="_blank" rel="noreferrer" className="text-primary">https://apdp.bj/</a>
                </p>
            </div>
        </div >
    )
}

export function Fiscality() {
    const { t } = useTranslation("translations")
    return (
        <div>
            {/* <h3>{t("general-conditions.allTerms.fiscality.title").toUpperCase()}</h3> */}
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.fiscality.description")}</p>
            </div>
        </div >
    )
}

export function Litige() {
    const { t } = useTranslation("translations")
    return (
        <div>
            {/* <h3>{t("general-conditions.allTerms.litige.headerTitle").toUpperCase()}</h3> */}
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.litige.description")}</p>
            </div>
        </div >
    )
}

export function Privacy() {
    const { t } = useTranslation("translations")
    const modalitiesCount = {
        total: 4,
        els: 3
    }
    return (
        <div>
            {/* <h3>{t("general-conditions.allTerms.privacy.title").toUpperCase()}</h3> */}
            <div className="mt-1rem">
                <p className="mt-1rem">{t("general-conditions.allTerms.privacy.subtitle")}</p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.1.title")}</h5>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.1.description"} >
                        En conformité, d’une part, avec la réglementation en vigueur sur la protection des données à caractère personnel (ci-après les « Données ») et, d’autre part, avec notre démarche de sécurité, de confidentialité et de protection continue des Données des utilisateurs de nos services, la présente Politique a pour objet de vous fournir certaines informations, notamment celles relatives à qui nous sommes, au traitement de vos Données, ainsi que l’exercice de vos droits concernant ces Données.<br />Veuillez lire attentivement ce qui suit pour comprendre nos pratiques concernant vos données personnelles et la manière dont nous les traitons.
                    </Trans>
                </p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.2.title")}</h5>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.2.description"} >
                        IZICHANGE fournit des Services d’Achat et de Vente de Crypto-actifs via le site internet <a href="https://izichange.com" aria-label="lien vers izichange" className="text-primary" />{{ site_lien: "https://izichange.com" }}<a /> (ci-après désignée la « Plateforme ») dont l’Éditeur est IZIGROUP, une Société à responsabilité limitée (SARL) dont le siège social est situé lot 0075 - Maison TOGONOU Mardeleine, Quartier Sodjéatimè, Boîte postale : 02 BP 348, Cotonou (République du Bénin), immatriculée au R.C.C.M. Bénin sous le numéro RC N°RCCM RB/COT/19 B 23954.
                    </Trans>
                </p>
                <div className="mt-1rem ml-1rem">
                    <h6>
                        {t("general-conditions.allTerms.privacy.description.2.description_detail_title")}
                    </h6>
                    <div className="mt-1rem">
                        <p className={clx("mt-5", style["text-lighten"])}>
                            {t("general-conditions.allTerms.privacy.description.2.description_detail_1", {
                                admin_name: "Edouard KOUGBLENOU",
                                admin_title: "+22997286954"
                            })}
                        </p>
                        <p className={clx("mt-5", style["text-lighten"])}>
                            <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.2.description_detail_2"} >
                                Adresse électronique : <a className="text-primary" href="mailto:compliance@izichange.com" aria-label="mailto:compliance@izichange.com">{{ complience_email: "compliance@izichange.com" }}</a>
                            </Trans>
                        </p>
                    </div>
                </div>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.3.title")}</h5>
                <div className="mt-1rem">
                    <p className="mb-10">
                        {t("general-conditions.allTerms.privacy.description.3.description_1")}
                    </p>
                    <ul>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.3.details.1")}
                        </li>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.3.details.2")}
                        </li>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.3.details.3")}
                        </li>
                    </ul>
                    <p className="mt-1rem">
                        {t("general-conditions.allTerms.privacy.description.3.description_2")}

                    </p>
                </div>

            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.5.title")}</h5>
                <div className="mt-1rem">
                    <p className="mb-10">
                        {t("general-conditions.allTerms.privacy.description.5.description_1")}
                    </p>
                    <ul>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.5.details.1")}
                        </li>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.5.details.2")}
                        </li>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.5.details.3")}
                        </li>

                    </ul>
                    <p className="mt-1rem">
                        {t("general-conditions.allTerms.privacy.description.5.description_2")}

                    </p>
                    <ul>

                        <li>
                            {t("general-conditions.allTerms.privacy.description.5.details.4")}
                        </li>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.5.details.5")}
                        </li>
                    </ul>
                </div>

            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.6.title")}</h5>
                {
                    Array.from(new Array(modalitiesCount.total)).map((_, i) => (
                        <table className={style.grouped} key={i}>
                            {
                                Array.from(new Array(modalitiesCount.els)).map((_, j) => (
                                    <React.Fragment key={j}>
                                        <tr>
                                            <th>{t(`general-conditions.allTerms.privacy.description.6.modalities.${i + 1}.${j + 1}.title`)}</th>
                                        </tr>
                                        <tr>
                                            <td>{t(`general-conditions.allTerms.privacy.description.6.modalities.${i + 1}.${j + 1}.description`)}</td>
                                        </tr>
                                    </React.Fragment>
                                ))

                            }
                        </table>
                    ))
                }

            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.7.title")}</h5>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.7.description_1"} >
                        Conformément aux dispositions de la Loi béninoise n° 2009-09 portant protection des données à caractère personnel et de la Loi n° 2017-20 portant code du numérique en République du Bénin (en son Livre 5ème relatif à la protection des données personnelles et de la vie privée), vos données sont collectées sur la base de votre consentement à leur traitement, lorsque ce dernier est nécessaire à l’exécution du contrat par IZICHANGE ou à l’exécution de mesures précontractuelles, sur la base d’une obligation légale ou encore d’un intérêt légitime de IZICHANGE.<br />Nous ne vous enverrons des communications de marketing direct par courrier électronique ou par SMS que si nous disposons de votre consentement.<br />Votre consentement à nous communiquer vos Données vaut également votre consentement pour partager celles-ci avec les tiers avec lesquels nous sommes susceptibles de transférer certaines de vos Données, pour les besoins du service.<br />Il s’agit notamment:
                    </Trans>
                </p>
                <ul>
                    <li>
                        {t("general-conditions.allTerms.privacy.description.7.details.1")}
                    </li>
                    <li>
                        {t("general-conditions.allTerms.privacy.description.7.details.2")}
                    </li>

                </ul>
                <p className="mt-1rem">
                    {t("general-conditions.allTerms.privacy.description.7.description_2")}
                </p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.8.title")}</h5>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.8.description"} >
                    </Trans>
                </p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.9.title")}</h5>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.9.description_1"} >
                    </Trans>
                </p>
                <p className="mt-10">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.9.description_2"} >
                    </Trans>
                </p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.10.title")}</h5>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.10.description"} >
                    </Trans>
                </p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.11.title")}</h5>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.11.description"} >
                        Toutes les informations que vous nous fournissez sont stockées sur nos serveurs sécurisés.<br />Vous êtes responsable de la confidentialité de vos mots de passe et codes vous permettant d’accéder à votre compte et à nos services. Nous vous demandons de ne pas les partager avec qui que ce soit.<br />Nous veillerons à ce que vos données personnelles ne soient accidentellement perdues, utilisées ou consultées de manière non autorisée, notamment en utilisant des procédures et des dispositifs de sécurité stricts.<br />Nous avons mis en place des procédures pour traiter tout soupçon de violation de données personnelles. Le cas échéant, nous vous en informerons, ainsi que les autorités compétentes, en l’occurrence l’Autorité de Protection des Données à caractère Personnel (APDP).
                    </Trans>
                </p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.12.title")}</h5>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.12.description"} >
                        Dans certaines circonstances, vous pouvez nous demander de supprimer vos données (voir la rubrique Vos droits légaux ci-dessous pour plus d'informations).<br /><br />Dans certaines circonstances, nous rendrons vos données personnelles anonymes (afin qu'elles ne puissent plus être associées à vous) à des fins de recherche ou de statistiques, auquel cas nous pouvons utiliser ces informations indéfiniment sans vous en informer.<br /><br />Si vous n'utilisez pas l'application pendant une période de 24 mois, nous considérerons que votre compte a expiré et vos données personnelles pourront être supprimées.<br /><br />Nous conservons vos Données le temps nécessaire pour les finalités poursuivies et conformément à nos obligations en matière de lutte contre le blanchiment de capitaux et le financement du terrorisme. Dans ce dernier cas, vos données de transactions seront conservées pendant une période de cinq ans suivant la clôture de votre compte et la fin de nos relations contractuelles.<br /><br />Quant aux enregistrements des communications téléphoniques, ils seront conservés pendant une période maximum de 60 jours à compter de l’enregistrement.<br /><br />Vos Données peuvent être conservées au-delà de la durée nécessaire en vue d'être traitées à des fins historiques, statistiques ou scientifiques.
                    </Trans>
                </p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.13.title")}</h5>
                <p className="mt-1rem">
                    {t("general-conditions.allTerms.privacy.description.13.description_1")}
                </p>
                <p className="mt-1rem"><span className="mr-10">-</span>{t("general-conditions.allTerms.privacy.description.13.details.1.title")}</p>
                <p className="mt-1rem">
                    {t("general-conditions.allTerms.privacy.description.13.description_2")}
                </p>
                <p className="mt-1rem">
                    {t("general-conditions.allTerms.privacy.description.13.description_3")}
                </p>
                <div className="ml-10">
                    <p className="mt-1rem"><span className="mr-10">-</span>{t("general-conditions.allTerms.privacy.description.13.details.2.title")}</p>
                    <ul>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.13.details.2.details.1")}
                        </li>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.13.details.2.details.2")}
                        </li>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.13.details.2.details.3")}
                        </li>
                        <li>
                            {t("general-conditions.allTerms.privacy.description.13.details.2.details.3")}
                        </li>

                    </ul>
                </div>
                <p className="mt-1rem"><span className="mr-10">-</span>{t("general-conditions.allTerms.privacy.description.13.details.3.title")}</p>
                <p className="mt-1rem"><span className="mr-10">-</span>{t("general-conditions.allTerms.privacy.description.13.details.4.title")}</p>
                <p className="mt-1rem"><span className="mr-10">-</span>{t("general-conditions.allTerms.privacy.description.13.details.5.title")}</p>
                <p className="mt-1rem"><span className="mr-10">-</span>{t("general-conditions.allTerms.privacy.description.13.details.6.title")}</p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.14.title")}</h5>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.14.description_1"} >
                        Vous pouvez exercer vos droits (voir la rubrique Vos droits légaux ci-dessus pour plus d'informations) en adressant une demande à notre Responsable du traitement aux adresses mentionnées ci-dessus (Voir rubrique Coordonnées). Toutefois, notre Responsable du traitement a le droit de s’opposer aux demandes manifestement abusives, notamment par leur nombre, leur caractère répétitif ou systématique.<br /><br />Toute personne demandant à exercer un droit doit justifier de son identité. Nous nous efforçons de traiter votre demande dans un délai raisonnable à compter de sa réception. A cette fin, nous sommes susceptibles de vous demander des informations ou des documents complémentaires.<br /><br />Une copie des Données traitées vous concernant vous est délivrée à votre demande. Toutefois, cette délivrance peut être subordonnée au paiement d’une somme correspondant au coût de la reproduction.
                    </Trans>
                </p>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.14.description_2"} >
                    </Trans>
                </p>
                <p className="mt-10 flex">
                    <span className="mr-10">-</span>
                    <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.14.description_3"} >
                        si vous avez des raisons sérieuses de penser qu’il y a un risque de dissimulation ou de disparition de vos Données, pour que l’APDP prenne toute mesure de nature à éviter cette dissimulation ou cette disparition ; - si vous avez des raisons sérieuses d’admettre que les données qui vous ont été communiquées ne sont pas conformes aux données traitées, pour que l’APDP procède aux vérifications nécessaires. Vous avez le droit d’introduire toute réclamation devant l’APDP à l’adresse suivante : Rue 6.076 « Immeuble El Marzouk Joël » COTONOU, Tél. : {{ tel: "+229 21 32 57 88" }} ; Email :{{ email: " contact@apdp.bj" }}.
                    </Trans>
                </p>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.15.title")}</h5>
                <ul>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.15.details.1"} >
                            <b>Le consenment</b> désigne votre accord pour le traitement de vos données personnelles, signifié par une déclaration ou une acceptation claire du traitement dans un but spécifique. Le consentement ne sera valable que s'il s'agit d'une indication libre, spécifique, expresse et sans ambiguïté de ce que vous voulez. Vous pouvez retirer votre consentement à tout moment en nous contactant.
                        </Trans>
                    </li>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.15.details.2"} >
                            <b>L'intérêt légitime</b> signifie l'intérêt de notre entreprise dans la conduite et la gestion de nos activités en vue de vous offrir le meilleur service/produit et l'expérience la meilleure et la plus sûre. Nous nous assurons de considérer et d'équilibrer tout impact potentiel sur vous (à la fois positif et négatif) et vos droits avant de traiter vos données personnelles pour nos intérêts légitimes. Nous n'utilisons pas vos données personnelles pour des activités dont l'impact sur vous l'emporte sur nos intérêts (sauf si nous avons votre consentement ou si la loi nous y oblige ou nous y autorise). Vous pouvez obtenir de plus amples informations sur la manière dont nous évaluons nos intérêts légitimes par rapport à tout impact potentiel sur vous dans le cadre d'activités spécifiques en nous contactant.
                        </Trans>
                    </li>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.15.details.3"} >
                            <b>Exécution du contrat</b> désigne la mise en œuvre du contrat dont certaines parties peuvent nécessiter le traitement de vos données ou celle des mesures prises à votre demande avant la conclusion du contrat.
                        </Trans>
                    </li>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.15.details.4"} >
                            <b>Respecter une obligation légale</b> signifie le fait pour nous de nous conformer à une disposition législative ou réglementaire encadrant le traitement de vos données personnelles.
                        </Trans>
                    </li>

                </ul>
            </div>
            <div className="mt-1rem">
                <h5 className={style.titleHighlited}>{t("general-conditions.allTerms.privacy.description.16.title")}</h5>
                <ul>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.16.details.1"} >
                            <b>Données d'identité </b>: prénom, nom, nom de jeune fille, nom d'utilisateur ou identifiant similaire, date et lieu de naissance.
                        </Trans>
                    </li>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.16.details.2"} >
                            <b>Données de contact </b>: adresse électronique (ou e-mail) et numéros de téléphone
                        </Trans>
                    </li>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.16.details.3"} >
                            <b>Données financières </b>: adresse cryptographique du Compte Crypto
                        </Trans>
                    </li>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.16.details.4"} >
                            <b>Données de transaction </b>: comprend les détails des paiements à destination et/ou en provenance de vous et les détails des Achats et des Ventes réalisées.
                        </Trans>
                    </li>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.16.details.5"} >
                            <b>Données relatives à l'appareil </b>: comprend le type d'appareil mobile que vous utilisez.
                        </Trans>
                    </li>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.16.details.6"} >
                            <b>Données de profil</b> : comprennent votre nom utilisateur, votre adresse électronique (ou e-mail) et votre mot de passe, l'historique de vos achats dans l'application, vos intérêts, vos préférences, vos commentaires et vos réponses aux enquêtes.
                        </Trans>
                    </li>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.16.details.7"} >
                            <b>Données d'utilisation </b>: comprennent les détails de votre utilisation de notre Plateforme, y compris, mais sans s'y limiter, les données de trafic
                        </Trans>
                    </li>
                    <li>
                        <Trans t={t} i18nKey={"general-conditions.allTerms.privacy.description.16.details.8"} >
                            <b>Données de marketing et de communication </b>: comprennent vos préférences en matière de réception de marketing de notre part et de celle de nos tiers, ainsi que vos préférences en matière de communication.
                        </Trans>
                    </li>
                </ul>
            </div>
        </div >
    )
}

export function SpecificRules() {
    const { t } = useTranslation("translations")
    const ulStyle = {
        display: "block",
        marginTop: '0.5rem',
        width: '100%',
    }
    const liStyle = {
        fontSize: '0.87rem',
        width: '100%',
    }
    return (
        <div>
            {/* <h3>{t("general-conditions.allTerms.specificRules.title").toUpperCase()}</h3> */}
            <div className="mt-1rem">
                <h5>{t("general-conditions.allTerms.specificRules.details.1.title")}</h5>
                <p className=" mt-1rem">{t("general-conditions.allTerms.specificRules.details.1.description")}</p>
                <div className="ml-10 mt-1rem">
                    <div className=" mt-1rem">
                        <h6>{t("general-conditions.allTerms.specificRules.details.1.details.1.title")}</h6>
                        <p>{t("general-conditions.allTerms.specificRules.details.1.details.1.description")}</p>
                    </div>
                    <div className=" mt-1rem">
                        <h6>{t("general-conditions.allTerms.specificRules.details.1.details.2.title")}</h6>
                        <p>{t("general-conditions.allTerms.specificRules.details.1.details.2.description")}</p>
                    </div>
                </div>
            </div>
            <div className="mt-1rem">
                <h5>{t("general-conditions.allTerms.specificRules.details.2.title")}</h5>
                <p className=" mt-1rem">
                    <Trans t={t} i18nKey="general-conditions.allTerms.specificRules.details.2.description"></Trans>
                </p>

            </div>
            <div className="mt-1rem">
                <h5>{t("general-conditions.allTerms.specificRules.details.3.title")}</h5>
                <p className=" mt-1rem">{t("general-conditions.allTerms.specificRules.details.3.description")}</p>

            </div>
            <div className="mt-1rem">
                <h5>{t("general-conditions.allTerms.specificRules.details.4.title")}</h5>
                <div className="ml-10 mt-1rem">
                    <div className="mt-1rem">
                        <h6>{t("general-conditions.allTerms.specificRules.details.4.details.1.title")}</h6>
                        <p className="mt-1rem">{t("general-conditions.allTerms.specificRules.details.4.details.1.description_1")}</p>
                        <ul style={ulStyle}>
                            <li style={liStyle}>{t("general-conditions.allTerms.specificRules.details.4.details.1.details.1")}</li>
                            <li style={liStyle}>{t("general-conditions.allTerms.specificRules.details.4.details.1.details.2")}</li>
                            <li style={liStyle}>{t("general-conditions.allTerms.specificRules.details.4.details.1.details.3")}</li>
                        </ul>
                        <p className="mt-1rem">{t("general-conditions.allTerms.specificRules.details.4.details.1.description_2")}</p>
                    </div>
                    <div className="mt-1rem">
                        <h6 className="mt-1rem">{t("general-conditions.allTerms.specificRules.details.4.details.2.title")}</h6>
                        <p className="mt-1rem">{t("general-conditions.allTerms.specificRules.details.4.details.2.description_1")}</p>
                        <ul className="mt-1rem" style={ulStyle}>
                            <li style={liStyle}>{t("general-conditions.allTerms.specificRules.details.4.details.2.details.1")}</li>
                            <li style={liStyle}>{t("general-conditions.allTerms.specificRules.details.4.details.2.details.2")}</li>
                            <li style={liStyle}>{t("general-conditions.allTerms.specificRules.details.4.details.2.details.3")}</li>
                            <li style={liStyle}>{t("general-conditions.allTerms.specificRules.details.4.details.2.details.4")}</li>
                        </ul>
                        <p className="mt-1rem">{t("general-conditions.allTerms.specificRules.details.4.details.2.description_2")}</p>
                    </div>
                    <div >
                        <h6 className="mt-1rem">{t("general-conditions.allTerms.specificRules.details.4.details.3.title")}</h6  >
                        <p className="mt-1rem">{t("general-conditions.allTerms.specificRules.details.4.details.3.description")}</p>
                        <ul className="" style={ulStyle}>
                            <li style={liStyle}>{t("general-conditions.allTerms.specificRules.details.4.details.3.details.1")}</li>
                            <li style={liStyle}>{t("general-conditions.allTerms.specificRules.details.4.details.3.details.2")}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div >
    )
}

export function GeneralRules() {
    const { t } = useTranslation("translations")
    const ulStyle = {
        display: "block",
        marginTop: '0.5rem',
        width: '100%',
    }
    const liStyle = {
        fontSize: '0.87rem',
        width: '100%',
    }
    return (
        <div>
            {/* <h3>{t("general-conditions.allTerms.generalRules.title").toUpperCase()}</h3> */}
            <div className="mt-1rem">
                <h5>
                    {t("general-conditions.allTerms.generalRules.details.1.title")}
                </h5>
                <p className="mt-1rem">
                    {t("general-conditions.allTerms.generalRules.details.1.description")}
                </p >
            </div>
            <div className="mt-1rem">
                <h5>
                    {t("general-conditions.allTerms.generalRules.details.2.title")}
                </h5>
                <p className="mt-1rem">

                    <Trans t={t} i18nKey="general-conditions.allTerms.generalRules.details.2.description">
                        La liste des Services proposés par IZICHANGE à ses Utilisateurs peut évoluer dans le temps. Ces Services sont communiqués à l’Utilisateur par l’intermédiaire de la Plateforme <a href="https://izichange.com" aria-label="izichange lien" className="text-primary">{{ site_lien: "https://izichange.com" }}</a>, du Compte Utilisateur et/ou d’un Chargé de Clientèle
                    </Trans>
                </p >
            </div>
            <div className="mt-1rem">
                <h5>
                    {t("general-conditions.allTerms.generalRules.details.3.title")}
                </h5>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey="general-conditions.allTerms.generalRules.details.3.description"></Trans>
                </p >
            </div>
            <div className="mt-1rem">
                <h5>
                    {t("general-conditions.allTerms.generalRules.details.4.title")}
                </h5>
                <p className="mt-1rem">
                    <Trans t={t} i18nKey="general-conditions.allTerms.generalRules.details.4.description"></Trans>
                </p >
            </div>
            <div className="mt-1rem">
                <h5>
                    {t("general-conditions.allTerms.generalRules.details.5.title")}
                </h5>
                <div className="mt-1rem">
                    <h6 className="mt-1rem ml-10">
                        {t("general-conditions.allTerms.generalRules.details.5.details.1.title")}
                    </h6>
                    <p className="mt-1rem">
                        <Trans t={t} i18nKey="general-conditions.allTerms.generalRules.details.5.details.1.description"></Trans>
                    </p >
                </div>
                <div className="mt-1rem">
                    <h6 className="mt-1rem ml-10">
                        {t("general-conditions.allTerms.generalRules.details.5.details.2.title")}
                    </h6>
                    <p className="mt-1rem">
                        {t("general-conditions.allTerms.generalRules.details.5.details.2.description")}
                    </p >
                </div>
                <div className="mt-1rem">
                    <h6 className="mt-1rem ml-10">
                        {t("general-conditions.allTerms.generalRules.details.5.details.3.title")}
                    </h6>
                    <p className="mt-1rem">
                        {t("general-conditions.allTerms.generalRules.details.5.details.3.description")}
                    </p >
                </div>
                <div className="mt-1rem">
                    <h6 className="mt-1rem ml-10">
                        {t("general-conditions.allTerms.generalRules.details.5.details.4.title")}
                    </h6>
                    <p className="mt-1rem">
                        {t("general-conditions.allTerms.generalRules.details.5.details.4.description")}
                    </p >
                </div>
                <div className="mt-1rem">
                    <h6 className="mt-1rem ml-10">
                        {t("general-conditions.allTerms.generalRules.details.5.details.5.title")}
                    </h6>
                    <p className="mt-1rem">
                        {t("general-conditions.allTerms.generalRules.details.5.details.5.description")}
                    </p >
                </div>
                <div className="mt-1rem">
                    <h6 className="mt-1rem ml-10">
                        {t("general-conditions.allTerms.generalRules.details.5.details.6.title")}
                    </h6>
                    <p className="mt-1rem">
                        {t("general-conditions.allTerms.generalRules.details.5.details.6.description")}
                    </p >
                </div>
                <div className="mt-1rem">
                    <h6 className="mt-1rem ml-10">
                        {t("general-conditions.allTerms.generalRules.details.5.details.7.title")}
                    </h6>
                    <p className="mt-1rem">
                        {t("general-conditions.allTerms.generalRules.details.5.details.7.description")}
                    </p >
                </div>
            </div>
            <div className="mt-1rem">
                <h5>
                    {t("general-conditions.allTerms.generalRules.details.6.title")}
                </h5>
                <div className="mt-1rem">
                    <h6 className="mt-1rem ml-10">
                        {t("general-conditions.allTerms.generalRules.details.6.details.1.title")}
                    </h6>
                    <p className="mt-1rem">
                        {t("general-conditions.allTerms.generalRules.details.6.details.1.description")}
                    </p >
                </div>
                <div className="mt-1rem">
                    <h6 className="mt-1rem ml-10">
                        {t("general-conditions.allTerms.generalRules.details.6.details.2.title")}
                    </h6>
                    <p className="mt-1rem">
                        <Trans t={t} i18nKey="general-conditions.allTerms.generalRules.details.6.details.2.description"></Trans>
                    </p >
                </div>
            </div>
            <div className="mt-1rem">
                <h5>
                    {t("general-conditions.allTerms.generalRules.details.7.title")}
                </h5>
                <p className="mt-1rem">
                    {t("general-conditions.allTerms.generalRules.details.7.description")}
                </p >
                <ul style={ulStyle}>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.7.details.1")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.7.details.2")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.7.details.3")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.7.details.4")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.7.details.5")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.7.details.6")}</li>
                </ul>
            </div>
            <div className="mt-1rem">
                <h5>
                    {t("general-conditions.allTerms.generalRules.details.8.title")}
                </h5>
                <p className="mt-1rem">
                    {t("general-conditions.allTerms.generalRules.details.8.description")}
                </p >
            </div>
            <div className="mt-1rem">
                <h5>
                    {t("general-conditions.allTerms.generalRules.details.9.title")}
                </h5>
                <p className="mt-1rem">
                    {t("general-conditions.allTerms.generalRules.details.9.description_1")}
                </p >
                <ul style={ulStyle}>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.9.details.1")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.9.details.2")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.9.details.3")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.9.details.4")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.9.details.5")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.generalRules.details.9.details.6")}</li>
                </ul>
                <p className="mt-1rem">
                    {t("general-conditions.allTerms.generalRules.details.9.description_2")}
                </p >
            </div>
            <div className="mt-1rem">
                <h5>
                    {t("general-conditions.allTerms.generalRules.details.10.title")}
                </h5>
                <p className="mt-1rem">
                    {t("general-conditions.allTerms.generalRules.details.10.description")}
                </p >
            </div>
        </div>
    )
}

export function Responsability() {
    const { t } = useTranslation("translations")
    const ulStyle = {
        display: "block",
        marginTop: '0.5rem',
        width: '100%',
    }
    const liStyle = {
        fontSize: '0.87rem',
        width: '100%',
    }
    return (
        <div>
            {/* <h3>{t("general-conditions.allTerms.responsability.title").toUpperCase()}</h3> */}
            <div className="mt-1rem">
                <h5>{t("general-conditions.allTerms.responsability.subtitle")}</h5>
                <h6 className="my-1rem">{t("general-conditions.allTerms.responsability.subtitle_description").toUpperCase()}</h6>
                <p>{t("general-conditions.allTerms.responsability.description_1")}</p>
                <ul className="" style={ulStyle}>
                    <li style={liStyle}>{t("general-conditions.allTerms.responsability.details.1")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.responsability.details.2")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.responsability.details.3")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.responsability.details.4")}</li>
                </ul>
            </div>
            <div className="mt-1rem">
                <p >{t("general-conditions.allTerms.responsability.description_2")}</p>
                <ul className="mt-1rem" style={ulStyle}>
                    <li style={liStyle}>{t("general-conditions.allTerms.responsability.details.5")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.responsability.details.6")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.responsability.details.7")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.responsability.details.8")}</li>
                    <li style={liStyle}>{t("general-conditions.allTerms.responsability.details.9")}</li>
                </ul>
            </div>
            <div className="mt-1rem">
                <p >{t("general-conditions.allTerms.responsability.description_3")}</p>
            </div>
        </div>
    )
}

export function Property() {
    const { t } = useTranslation("translations")
    return (
        <div>
            {/* <h3>{t("general-conditions.allTerms.property.headerTitle").toUpperCase()}</h3> */}

            <div className="mt-1rem">
                 {/* <p className="mt-1rem">{t("general-conditions.allTerms.litige.description")}</p> */}
              
                <p className="mt-1rem">{t("general-conditions.allTerms.property.description")}</p>
            </div>
        </div >
    )
}


export function Lexique() {
    const { t } = useTranslation("translations")
    const ulStyle = {
        display: "block",
        marginTop: '0.5rem',
        width: '100%',
    }
    const liStyle = {
        fontSize: '0.87rem',
        width: '100%',
    }

    return (
        <>
            <section>
                <div className={style.container_content}>
                    <div className={style.conditions} style={{padding:'1rem'}}>
                        <h3>{t("lexique.title")}</h3>
                        <p className="mt-1rem">
                            <Trans t={t} i18nKey="lexique.description_1"></Trans>
                        </p>
                        <ul className="" style={ulStyle}>
                            <li style={liStyle}>{t("lexique.details.1")}</li>
                            <li style={liStyle}>{t("lexique.details.2")}</li>
                        </ul>
                        <p className="mt-1rem">
                            <Trans t={t} i18nKey="lexique.description_2"></Trans>
                        </p>
                        <ul className="" style={ulStyle}>
                            <li style={liStyle}>{t("lexique.details.3")}</li>
                            <li style={liStyle}>{t("lexique.details.4")}</li>
                        </ul>

                        <p className="mt-1rem">
                            <Trans t={t} i18nKey="lexique.description_3"></Trans>
                        </p>
                        <ul className="" style={ulStyle}>
                            <li style={liStyle}>{t("lexique.details.5")}</li>
                            <li style={liStyle}>{t("lexique.details.6")}</li>
                            <li style={liStyle}>{t("lexique.details.7")}</li>
                            <li style={liStyle}>{t("lexique.details.8")}</li>
                        </ul>
                        <p className="mt-1rem">
                            <Trans t={t} i18nKey="lexique.description_4"></Trans>
                        </p>
                    </div>
                </div>
            </section>
        </>
    )
}

export function PolitiqueConf() {
    const { t } = useTranslation("translations")
    // const [loading, setLoading] = React.useState(localStorage.getItem('isLoading') === 'true' || false)
     
    useEffect(()=>CheckAndHideFooter(),[])
    const tableStyle = {
        border: '1px solid black',
    };
      
    const rowStyle = {
    border: '1px solid black',
    };
      
    const cellStyle = {
        border: '1px solid black',
        padding: '1rem'
    };

    const titleStyle = {
        color: "#000",
        fontWeight: 'bold'
    };

    const subtitleStyle = {
        color: "#000",
        fontWeight: 'bold',
        fontSize: 15
    }


    return (
        <>
            <section>
                <div className={style.container_content}>
                    <div className={style.conditions} id="cond">
                        
                        <div className={style.app}>
                            {/* {
                                isHidden && (
                                    <motion.nav
                                        className={`${style.sidebar} ${isHidden ? style.hidden : ''}`}
                                        initial={{ x: -200 }}
                                        animate={{ x: 0 }} 
                                        transition={{ type: 'spring', stiffness: 100 }}
                                    >
                                        <div onClick={() => scrollToSection('section1')}>{t('politique-conf.sommary.sommary-1')}</div>
                                        <div onClick={() => scrollToSection('section2')}>{t('politique-conf.sommary.sommary-2')}</div>
                                        <div onClick={() => scrollToSection('section3')}>{t('politique-conf.sommary.sommary-3')}</div>
                                        <div onClick={() => scrollToSection('section4')}>{t('politique-conf.sommary.sommary-4')}</div>
        
                                        <div onClick={() => scrollToSection('section5')}>{t('politique-conf.sommary.sommary-5')}</div>
                                        <div onClick={() => scrollToSection('section6')}>{t('politique-conf.sommary.sommary-6')}</div>
                                        <div onClick={() => scrollToSection('section7')}>{t('politique-conf.sommary.sommary-7')}</div>
                                        <div onClick={() => scrollToSection('section8')}>{t('politique-conf.sommary.sommary-8')}</div>
        
                                        <div onClick={() => scrollToSection('section9')}>{t('politique-conf.sommary.sommary-9')}</div>
                                        <div onClick={() => scrollToSection('section10')}>{t('politique-conf.sommary.sommary-10')}</div>
                                    </motion.nav>
                                )
                            } */}
                            
        
                            {/* <nav className={style.sidebar}> */}
                                {/* <ul> */}
                                {/* <div onClick={() => scrollToSection('section1')}>{t('politique-conf.sommary.sommary-1')}</div>
                                <div onClick={() => scrollToSection('section2')}>{t('politique-conf.sommary.sommary-2')}</div>
                                <div onClick={() => scrollToSection('section3')}>{t('politique-conf.sommary.sommary-3')}</div>
                                <div onClick={() => scrollToSection('section4')}>{t('politique-conf.sommary.sommary-4')}</div>
        
                                <div onClick={() => scrollToSection('section5')}>{t('politique-conf.sommary.sommary-5')}</div>
                                <div onClick={() => scrollToSection('section6')}>{t('politique-conf.sommary.sommary-6')}</div>
                                <div onClick={() => scrollToSection('section7')}>{t('politique-conf.sommary.sommary-7')}</div>
                                <div onClick={() => scrollToSection('section8')}>{t('politique-conf.sommary.sommary-8')}</div>
        
                                <div onClick={() => scrollToSection('section9')}>{t('politique-conf.sommary.sommary-9')}</div>
                                <div onClick={() => scrollToSection('section10')}>{t('politique-conf.sommary.sommary-10')}</div> */}
                                
                                
                                {/* </ul> */}
                            {/* </nav> */}
                            <motion.main
                                className={style.content}
                                // initial={{ x: 200 }} 
                                // animate={{ x: 0 }} 
                                // transition={{ type: 'spring', stiffness: 100 }}
                            >
                                <div className={style.display}>
                                    {/* <BsCardList style={{ fontSize: '1.5rem'}} onClick={() => {
                                        handleIcon();
                                    }}/> */}
                                </div>
                                <div className={style.wrapperContent}>
                                    
                                    <MentionLegales />
                                    <div className={style.container_content}>
                                    <h2 style={{fontSize: '1.2rem'}}>{t("politique-conf.title")}</h2>
                                        <section id="section1" className={style.section}>
                                            <h2 style={{marginTop:10, fontSize: '1.1rem'}}>1- {t('politique-conf.sommary.sommary-1')}</h2>
                                            <p>{t('politique-conf.description1.description-1')}<br/><br/>
                                                {t('politique-conf.description1.description-2')}<br/><br/>
                                                {t('politique-conf.description1.description-3')}<br/><br/>
                                                <ul>
                                                    <li>{t('politique-conf.description1.description-4')}</li><br/>
                                                    <li>{t('politique-conf.description1.description-5')}</li><br/>
                                                    <li>{t('politique-conf.description1.description-6')}</li>
                                                </ul>
                                                {t('politique-conf.description1.description-7')}</p>
                                        </section>
                                        <section id="section2" className={style.section}>
                                            <h2 style={{marginTop:10, fontSize: '1.1rem'}}>2- {t('politique-conf.sommary.sommary-2')}</h2>
                                            <p>{t('politique-conf.description2.description-1')}<br/><br/>
                                                1. {t('politique-conf.description2.description-2')}<br/><br/>
                                                2. {t('politique-conf.description2.description-3')}<br/><br/>
                                                3. {t('politique-conf.description2.description-4')}<br/><br/>
                                                4. {t('politique-conf.description2.description-5')}<br/><br/>
                                                5. {t('politique-conf.description2.description-6')}<br/><br/>
                                                6. {t('politique-conf.description2.description-7')}<br/><br/>
                                                7. {t('politique-conf.description2.description-8')}<br/><br/>
                                                8. {t('politique-conf.description2.description-9')}
                                            </p>
                                        </section>
                                        <section id="section3" className={style.section}>
                                            <h2 style={{marginTop:10, fontSize: '1.1rem'}}>3- {t('politique-conf.sommary.sommary-3')}</h2>
                                            <p>
                                                {t('politique-conf.description3.description')}
                                            </p>
                                        </section>
        
                                        <section id="section4" className={style.section}>
                                            <h2 style={{marginTop:10, fontSize: '1.1rem'}}>4- {t('politique-conf.sommary.sommary-4')}</h2>
                                            <p>{t('politique-conf.description4.description')}
                                                <a href="mailto:compliance@izichange.com" aria-label="lien compliance" target="_blank"  rel="noreferrer"  style={{ color: '#008080'}}>compliance@izichange.com</a> .
                                            </p>
                                        </section>
        
                                        <section id="section5" className={style.section}>
                                            <h2 style={{marginTop:10, fontSize: '1.1rem'}}>5- {t('politique-conf.sommary.sommary-5')}</h2>
                                            <p>
                                                {t('politique-conf.description5.description-1')}<br/>
                                                <table style={tableStyle}>
                                                    <thead>
                                                        <tr className="_table_header" style={rowStyle}>
                                                            <th>{t('politique-conf.description5.description-2')} </th>
                                                            <th>{t('politique-conf.description5.description-3')}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        
                                                        <tr style={rowStyle}>
                                                            <td style={cellStyle}>
                                                                <p className="crypto_label">
                                                                    <span style={titleStyle}>{t('politique-conf.description5.description-4')}</span>
                                                                </p>
                                                            </td>
                                                            <td style={cellStyle}>
                                                                <p className="crypto_label">
                                                                    <span>
                                                                        {t('politique-conf.description5.description-5')}
                                                                    </span>
                                                                </p>
                                                            </td>
                                                        </tr>
                                                        <tr style={rowStyle}>
                                                            <td style={cellStyle}>
                                                                <p style={titleStyle}>{t('politique-conf.description5.description-6')}</p>
                                                            </td>
                                                            <td style={cellStyle}>
                                                                <p>
                                                                    {t('politique-conf.description5.description-7')}
                                                                </p>
                                                            </td>
                                                            
                                                        </tr>
                                                        <tr style={rowStyle}>
                                                            <td style={cellStyle}>
                                                                <p style={titleStyle}>{t('politique-conf.description5.description-8')}</p>
                                                            </td>
                                                            <td style={cellStyle}>
                                                                <p>{t('politique-conf.description5.description-9')}</p>
                                                            </td>
                                                        </tr>
        
                                                        <tr style={rowStyle}>
                                                            <td style={cellStyle}>
                                                                <p style={titleStyle}>{t('politique-conf.description5.description-10')}</p>
                                                            </td>
                                                            <td style={cellStyle}>
                                                                <p>
                                                                    {t('politique-conf.description5.description-11')}
                                                                </p>
                                                            </td>
                                                        </tr>
        
                                                        <tr style={rowStyle}>
                                                            <td style={cellStyle}>
                                                                <p style={titleStyle}>{t('politique-conf.description5.description-12')} </p>
                                                            </td>
                                                            <td style={cellStyle}>
                                                                <p>
                                                                    {t('politique-conf.description5.description-13')}
                                                                </p>
                                                            </td>
                                                        </tr>
        
                                                        <tr style={rowStyle}>
                                                            <td style={cellStyle}>
                                                                <p style={titleStyle}>{t('politique-conf.description5.description-14')}</p>
                                                            </td>
                                                            <td style={cellStyle}>
                                                                <p>{t('politique-conf.description5.description-15')}</p>
                                                            </td>
                                                        </tr>
        
                                                    </tbody>
                                                </table>
                                                <br />
                                                {t('politique-conf.description5.description-16')}<br/>
                                                {t('politique-conf.description5.description-17')}<br/><br/>
                                                {t('politique-conf.description5.description-18')}<br/><br/>
                                                {t('')}
                                            </p>
                                        </section>
        
                                        <section id="section6" className={style.section}>
                                            <h2 style={{marginTop:10, fontSize: '1.1rem'}}>6- {t('politique-conf.sommary.sommary-6')}</h2>
                                            <p>
                                                <span style={titleStyle}>6.1. {t('politique-conf.description6.description-1')}</span> <br/>
        
                                                {t('politique-conf.description6.description-2')}<br/>
                                                {t('politique-conf.description6.description-3')}<br/>
                                                {t('politique-conf.description6.description-4')}<br/><br/>
        
                                                <span style={titleStyle}>6.2. {t('politique-conf.description6.description-5')}</span><br/>
                                                {t('politique-conf.description6.description-6')}<br/>
                                                {t('politique-conf.description6.description-7')}<br/><br/>
        
                                                <span style={titleStyle}>6.3. {t('politique-conf.description6.description-8')}</span>
                                                <br/>
                                                {t('politique-conf.description6.description-9')}<br/><br/>
                                                {t('politique-conf.description6.description-10')}<br/><br/>
                                                <ul>
                                                    <li>{t('politique-conf.description6.description-11')}</li><br/>
                                                    <li>{t('politique-conf.description6.description-12')}</li><br/>
                                                    <li>{t('politique-conf.description6.description-13')}</li><br/>
                                                    <li>{t('politique-conf.description6.description-14')}</li>
                                                </ul><br />
        
                                                <span style={titleStyle}>6.4. {t('politique-conf.description6.description-15')}</span>
                                                <br/>
                                                {t('politique-conf.description6.description-16')}<br/><br/>
        
                                                <span style={subtitleStyle}>6.4.1. {t('politique-conf.description6.description-17')}</span>
                                                <br/>
                                                {t('politique-conf.description6.description-18')}<br/><br/>
                                                <ul>
                                                    <li>{t('politique-conf.description6.description-19')}</li><br/>
                                                    <li>{t('politique-conf.description6.description-20')}</li><br/>
                                                    <li>{t('politique-conf.description6.description-21')}</li>
                                                </ul><br/>
        
                                                <span style={subtitleStyle}>6.4.2. {t('politique-conf.description6.description-22')}</span>
                                                <br/>
                                                {t('politique-conf.description6.description-23')}<br/><br/>
        
                                                <span style={subtitleStyle}>6.4.3. {t('politique-conf.description6.description-24')}</span>
                                                <br/>
                                                {t('politique-conf.description6.description-25')}<br/><br/>
                                                <ul>
                                                    <li>{t('politique-conf.description6.description-26')}</li><br/>
                                                    <li>{t('politique-conf.description6.description-27')}</li><br/>
                                                    <li>{t('politique-conf.description6.description-28')}</li>
                                                </ul>
                                                {t('politique-conf.description6.description-29')}<br/><br/>
        
                                                <span style={subtitleStyle}>6.4.4. {t('politique-conf.description6.description-30')}</span>
                                                <br/>
                                                {t('politique-conf.description6.description-31')}<br/><br/>
                                                <ul>
                                                    <li>{t('politique-conf.description6.description-32')}</li><br/>
                                                    <li>{t('politique-conf.description6.description-33')}</li>
                                                </ul>
                                                {t('politique-conf.description6.description-34')}<br/><br/>
        
                                                <span style={titleStyle}>6.5. {t('politique-conf.description6.description-35')}</span>
                                                <br/>
                                                {t('politique-conf.description6.description-36')}<br/><br/>
                                                <ul>
                                                    <li>{t('politique-conf.description6.description-37')}</li><br/>
                                                    <li>{t('politique-conf.description6.description-38')}</li><br/>
                                                    <li>{t('politique-conf.description6.description-39')}</li><br/>
                                                    <li>{t('politique-conf.description6.description-40')}</li><br/>
                                                    <li>{t('politique-conf.description6.description-41')}</li><br/>
                                                </ul>
                                                {t('politique-conf.description6.description-42')}<br/><br/>
        
                                                <span style={titleStyle}>6.6. {t('politique-conf.description6.description-43')}</span>
                                                <br/>
                                                {t('politique-conf.description6.description-44')}<br/><br/>
                                                {t('politique-conf.description6.description-45')}<br/>
                                                {t('politique-conf.description6.description-46')}
                                            </p>
                                        </section>
        
                                        <section id="section7" className={style.section}>
                                            <h2 style={{marginTop:10, fontSize: '1.1rem'}}>7- {t('politique-conf.sommary.sommary-7')}</h2>
                                            <p>
                                                {t('politique-conf.description7.description-1')}<br/>
                                                {t('politique-conf.description7.description-2')}<br/><br/>
                                                <ul>
                                                    <li>{t('politique-conf.description7.description-3')}</li><br/>
                                                    <li>{t('politique-conf.description7.description-4')} :</li><br/>
                                                </ul>
                                                ➢ {t('politique-conf.description7.description-5')} <br/><br/>
                                                ➢ {t('politique-conf.description7.description-6')} <br/><br/>
                                                ➢ {t('politique-conf.description7.description-7')}
                                            </p>
        
                                            <table style={tableStyle}>
                                                <thead>
                                                    <tr className="_table_header" style={rowStyle}>
                                                        <th>{t('politique-conf.description7.description-8')}</th>
                                                        <th>{t('politique-conf.description7.description-9')} </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    
                                                    <tr style={rowStyle}>
                                                        <td style={cellStyle}>
                                                            <p className="crypto_label">
                                                                <span>{t('politique-conf.description7.description-10')} </span>
                                                            </p>
                                                        </td>
                                                        <td style={cellStyle}>
                                                            <p className="crypto_label">
                                                                <span>
                                                                    {t('politique-conf.description7.description-11')}
                                                                </span>
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr style={rowStyle}>
                                                        <td style={cellStyle}>
                                                            <p>{t('politique-conf.description7.description-12')} </p>
                                                        </td>
                                                        <td style={cellStyle}>
                                                            <p>{t('politique-conf.description7.description-13')} </p>
                                                        </td>
                                                        
                                                    </tr>
                                                    <tr style={rowStyle}>
                                                        <td style={cellStyle}>
                                                            <p>{t('politique-conf.description7.description-14')} </p>
                                                        </td>
                                                        <td style={cellStyle}>
                                                            <p>
                                                                {t('politique-conf.description7.description-15')}
                                                            </p>
                                                        </td>
                                                    </tr>
        
                                                </tbody>
                                            </table>
        
                                        </section><br/>
        
                                        <section id="section8" className={style.section}> 
                                            <h2 style={{marginTop:10, fontSize: '1.1rem'}}>8- {t('politique-conf.sommary.sommary-8').toUpperCase()}</h2><br/>
                                            <p>
                                                {t('politique-conf.description8.description-1')} <br/>
                                                {t('politique-conf.description8.description-2')} <br/>
                                            </p>
                                        </section>
        
                                        <section id="section9" className={style.section}>
                                            <h2 style={{marginTop:10, fontSize: '1.1rem'}}>9- {t('politique-conf.sommary.sommary-9').toUpperCase()}</h2>
                                            <p>
                                                <span style={titleStyle}>9.1. {t('politique-conf.description9.description-1')} </span>
                                                <br/><br/>
                                                {t('politique-conf.description9.description-2')} <br/><br/>
                                                <ul>
                                                    <li>{t('politique-conf.description9.description-3')}</li><br/><br/>
                                                    <li>{t('politique-conf.description9.description-4')}</li><br/><br/>
                                                    <li>{t('politique-conf.description9.description-5')}</li><br/><br/>
                                                    <li>{t('politique-conf.description9.description-6')}</li><br/><br/>
                                                    <li>{t('politique-conf.description9.description-7')}</li><br/><br/>
                                                    <li>{t('politique-conf.description9.description-8')}</li><br/><br/>
                                                    
                                                </ul> 
                                                <span style={titleStyle}>9.2. {t('politique-conf.description9.description-9')}</span>
                                                <br/>
                                                {t('politique-conf.description9.description-10')} <br/>
                                                {t('politique-conf.description9.description-11')} <br/><br/>
                                                {t('politique-conf.description9.description-12')} <br/><br/>
                                                {t('politique-conf.description9.description-13')} <br/>
                                                {t('politique-conf.description9.description-14')} <br/><br/>
                                                <ul>
                                                    <li>{t('politique-conf.description9.description-15')}</li><br/>
                                                    <li>{t('politique-conf.description9.description-16')}</li><br/>
                                                    <li>{t('politique-conf.description9.description-17')}</li><br/>
                                                </ul>
                                                
                                                {t('politique-conf.description9.description-18')} <br/>
                                                {t('politique-conf.description9.description-19')} <a style={{ color: '#008080'}} href="http://apdp.bj/wp-content/uploads/2018/11/Modèle-de-lettre-plainte-Validé.pdf">http://apdp.bj/wp-content/uploads/2018/11/Modèle-de-lettre-plainte-Validé.pdf</a>
                                            </p>
        
                                            <DownloadPDF />
                                        </section>
                                    </div>
                                </div>
                            </motion.main>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export function DownloadPDF({buttonStyle,label=null}) {
    const { t } = useTranslation("translations")

    const defaultButtonStyle = {
        backgroundColor: '#008080',
        color: '#fff',
        border: 'none',
        borderRadius: '0.7rem',
        padding: '0.5rem 0.7rem',
        cursor: 'pointer',
        fontSize: '0.7rem',
        transition: 'backgroundColor 0.3s ease',
        marginTop: '15px',
        fontFamily: 'Typold Regular'
    }

    const buttonStyles = buttonStyle || defaultButtonStyle;

    const handleDownload = () => {
        const pdfUrl = 'https://home.izichange.com/images/izichange.pdf'; // Chemin vers votre fichier PDF
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = 'exercer_vos_droits_izichange.pdf'; // Nom du fichier téléchargé
        link.target = '_blank'; // Pour ouvrir le lien dans un nouvel onglet
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };
    return (
        <span>
            <button style={buttonStyles} onClick={handleDownload}>{label??t('politique-conf.download')}</button>
        </span>
    );
}

export function MentionLegales() {
    const { t } = useTranslation("translations") 
    return (
        <>
            <section>
                <div className={style.container_content}>
                    <div className={style.conditions} style={{padding:'1rem'}}>
                        <h2>{t("mentions.title")}</h2>
                        <div className="mt-2rem">
                            <h5 className={style.titleHighlited}>{t("mentions.details.1.title")}</h5>
                            <p className="mt-1rem">
                                <Trans t={t} i18nKey="mentions.details.1.description">
                                    Le Site internet (<a href="https://izichange.com/" aria-label="izichange" className="text-primary">{{ site_lien: "https://izichange.com/" }}</a>) appartient à IZICHANGE, une société par actions simplifiée (SAS) enregistrée au RCCM de la République du Bénin sous le numéro RB/ABC/21 B 4180 et dont le siège social est à Abomey-Calavi Quartier TOKPA ZOUNGO Immeuble Fondation Suzane MEDE 02 BP 348 Cotonou Bénin.<br /><br />Le Directeur de la publication est OKOUIN Babatunde Marius
                                </Trans>
                            </p>
                        </div>
                        <div className="mt-2rem">
                            <h5 className={style.titleHighlited}>{t("mentions.details.2.title")}</h5>
                            <p className="mt-1rem">
                                <Trans t={t} i18nKey="mentions.details.2.description">
                                </Trans>
                            </p>

                        </div>
                        <div className="mt-2rem">
                            <h5 className={style.titleHighlited}>{t("mentions.details.3.title")}</h5>
                            <p className="mt-1rem">
                                <Trans t={t} i18nKey="mentions.details.3.description" >
                                    <a href="mailto:info@izichange.com" aria-label="Contact Izichange via email at info@izichange.com" rel="noreferrer" target="_blank" className="text-primary">{{ site_info_email: "info@izichange.com" }}</a>
                                </Trans>
                            </p>
                        </div>
                        <div className="mt-2rem">
                            <h5 className={style.titleHighlited}>{t("mentions.details.4.title")}</h5>
                            <p className="mt-1rem">
                                <Trans t={t} i18nKey="mentions.details.4.description">
                                    Le site et les services web <a href="https://izichange.com/" aria-label="Link to Izichange website" className="text-primary">{{ site_lien: "https://izichange.com/" }}</a> sont hébergés par la société :<br /><br />Contabo GmbH.<br /><br />Aschauer Strasse 32a,81549 Munich, Germany<br /><br />site web: <a href="https://www.contabo.com/" aria-label="https://www.contabo.com" target="_blank" rel="noreferrer" className="text-primary">{{ hosting_lient: " https://www.contabo.com/" }}</a>
                                </Trans>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export function Cookies() {
    const { t } = useTranslation("translations")
      
    return (
        <>
            <section>
                <div className={style.container_content}>
                    <div className={style.conditions} style={{padding:'1rem'}}>
                        <h2>{t("policy.title")}</h2>
                        <div className="mt-2rem">
                            <h5 className={style.titleHighlited}>{t("policy.details.1.title")}</h5>
                            <p className="mt-1rem">
                                <Trans t={t} i18nKey="policy.details.1.description">
                                </Trans>
                            </p>
                        </div>
                        <div className="mt-2rem">
                            <h5 className={style.titleHighlited}>{t("policy.details.2.title")}</h5>
                            <p className="mt-1rem">
                                <Trans t={t} i18nKey="policy.details.2.description">
                                </Trans>
                            </p>

                        </div>
                        <div className="mt-2rem">
                            <h5 className={style.titleHighlited}>{t("policy.details.3.title")}</h5>
                            <p className="mt-1rem">
                                <Trans t={t} i18nKey="policy.details.3.description" >
                                </Trans>
                            </p>
                        </div>
                        <div className="mt-2rem">
                            <h5 className={style.titleHighlited}>{t("policy.details.4.title")}</h5>
                            <p className="mt-1rem">
                                <Trans t={t} i18nKey="policy.details.4.description">
                                </Trans>
                            </p>
                        </div>
                        <div className="mt-2rem">
                            <h5 className={style.titleHighlited}>{t("policy.details.5.title")}</h5>
                            <p className="mt-1rem">
                                <Trans t={t} i18nKey="policy.details.5.description">
                                    Nous espérons que cela a clarifié les choses pour vous et comme cela a été mentionné précédemment si vous ne savez pas si vous avez besoin ou non, il est généralement plus sûr de laisser les cookies activés dans le cas où ils interagissent avec l'une des Fonctionnalités que vous utilisez sur notre site. Cependant, si vous désirez obtenir davantage d'informations, vous pouvez nous contacter: <a href="mailto:info@izichange.com" aria-label="lien info@izichange.com" target="_blank" rel="noreferrer" className="text-primary">{{ site_email: "info@izichange.com" }}</a>.
                                </Trans>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export function Warning() {
    const { t } = useTranslation("translations")
    const ulStyle = {
        display: "block",
        marginTop: '0.5rem',
        width: '100%',
    }
    const liStyle = {
        fontSize: '0.87rem',
        width: '100%',
    } 
    
    return (
        <>
            <section>
            <div className={style.container_content}>
            <div className={style.conditions} style={{padding:'1rem'}}>
                <h2 className="">{t("warning.title")}</h2>
                <h3 className="mt-2rem">{t("warning.subtitle")}</h3>
                <h5 className={clx("mt-2rem", style.titleHighlited)}>{t("warning.subtitle_description")}</h5 >
                <div className="mt-1rem">
                    <p className="mt-1rem"><Trans i18nKey={"warning.description_1"} t={t}></Trans></p>
                    <ul className="" style={ulStyle}>
                        <li style={liStyle}>{t("warning.details.1")}</li>
                        <li style={liStyle}>{t("warning.details.2")}</li>
                        <li style={liStyle}>{t("warning.details.3")}</li>
                    </ul>
                    <p className="mt-1rem"><Trans i18nKey={"warning.description_2"} t={t}></Trans></p>
                    <ul className="" style={ulStyle}>
                        <li style={liStyle}>{t("warning.details.4")}</li>
                        <li style={liStyle}>{t("warning.details.5")}</li>
                        <li style={liStyle}>{t("warning.details.6")}</li>
                        <li style={liStyle}>{t("warning.details.7")}</li>
                        <li style={liStyle}>{t("warning.details.8")}</li>
                        <li style={liStyle}>{t("warning.details.9")}</li>
                        <li style={liStyle}>{t("warning.details.10")}</li>
                        <li style={liStyle}>{t("warning.details.11")}</li>
                        <li style={liStyle}>{t("warning.details.12")}</li>
                    </ul>
                    <p className="mt-1rem"><Trans i18nKey={"warning.description_3"} t={t}></Trans></p>
                </div>
            </div>
        </div>
            </section>
        </>
    )
}

